(function($){

    'use strict';

    class CarouselBrands extends HTMLElement {
        constructor() {
            super();
            
            setTimeout(() => {
                theme.AssetsLoader.onScrollOrUserAction(this, () => {
                    this.load();
                });
            }, 0);
        }

        load() {
            this.$container = $(this);

            var _ = this,
                $carousel = this.$container.find('[data-js-carousel]'),
                $slick = $carousel.find('[data-js-carousel-slick]');

            function initialize() {
                var $prev = $carousel.find('[data-js-carousel-prev]'),
                    $next = $carousel.find('[data-js-carousel-next]'),
                    $arrows = $carousel.find('[data-js-carousel-arrow]'),
                    count = +$carousel.attr('data-count'),
                    autoplay = $carousel.attr('data-autoplay') === 'true' ? true : false,
                    speed = +$carousel.attr('data-speed'),
                    infinite = $carousel.attr('data-infinite') === 'true' ? true : false,
                    arrows = false,
                    bullets = $carousel.attr('data-bullets') === 'true' ? true : false;


                _.$slick = $slick;

                function arrowsPosition() {
                    var max_height = 0;

                    $slick.find('.carousel__item').each(function () {
                        max_height = Math.max(max_height, $(this).innerHeight());
                    });

                    $arrows.css({top: max_height / 2});
                };

                if (arrows) {
                    $window.on('theme.resize.carousel-messaging', arrowsPosition);
                }

                $slick.on('init', function () {
                    if (arrows) {
                        arrowsPosition();
                    }

                    $(window).trigger('checkImages');
                    $carousel.removeClass('invisible');
                    theme.Preloader.unset($carousel.parent());
                });

                $slick.slick({       
                    lazyLoad: false,            
                    arrows: false,
                    prevArrow: $prev,
                    nextArrow: $next,
                    dots: bullets,
                    dotsClass: 'slick-dots d-flex flex-wrap flex-center list-unstyled pt-40',
                    adaptiveHeight: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    speed: speed,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,  
                    cssEase:'linear',  
                    fade: true,         
                    rows: 1,
                    touchMove: true,
                    pauseOnHover: false,
                    rtl: theme.rtl,
                    responsive: [ 
                        {
                            breakpoint: theme.breakpoints.values.xl,
                            settings: {
                                autoplay: true,
                                slidesToShow: 1,
                                slidesToScroll: 1                               
                            }
                        },
                        {
                            breakpoint: theme.breakpoints.values.lg,
                            settings: {
                                autoplay: true,
                                slidesToShow: 1,
                                slidesToScroll: 1                               
                            }
                        },
                        {
                            breakpoint: theme.breakpoints.values.md,
                            settings: {
                                autoplay: true,
                                slidesToShow: 1,
                                slidesToScroll: 1                               
                            }
                        },
                        {
                            breakpoint: theme.breakpoints.values.sm,
                            settings: {
                                autoplay: true,
                                slidesToShow: 1,
                                slidesToScroll: 1                                
                              
                            }
                        }
                    ]
                });
            };

            if($slick.length) {
                theme.AssetsLoader.loadManually([
                    ['styles', 'plugin_slick'],
                    ['scripts', 'plugin_slick']
                ],
                function() {
                    initialize();
                });
            }
        }

        disconnectedCallback() {
            if(this.$slick) {
                this.$slick.slick('destroy').off();
                this.$slick = null;

                $window.unbind('theme.resize.carousel-messaging');
            }
        }
    }

    theme.AssetsLoader.onPageLoaded(function() {
        customElements.define('carousel-messaging', CarouselBrands);
    });
})(jQueryTheme);